import { render, staticRenderFns } from "./consultationdialog.vue?vue&type=template&id=6528acbd&scoped=true"
import script from "./consultationdialog.vue?vue&type=script&lang=js"
export * from "./consultationdialog.vue?vue&type=script&lang=js"
import style0 from "./consultationdialog.vue?vue&type=style&index=0&id=6528acbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528acbd",
  null
  
)

export default component.exports